import { render } from "./GymnastiqueHypopressive.vue?vue&type=template&id=dff9c488&scoped=true"
import script from "./GymnastiqueHypopressive.vue?vue&type=script&lang=js"
export * from "./GymnastiqueHypopressive.vue?vue&type=script&lang=js"

import "./GymnastiqueHypopressive.vue?vue&type=style&index=0&id=dff9c488&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff9c488"]])

export default __exports__